/********************************************
 * Image Link Widget
 *******************************************/

/********************************************
 * Node Modules
 *******************************************/
import PropTypes from "prop-types";
import classNames from "classnames";

/********************************************
 * Local Imports
 *******************************************/
import CallToAction from "../Card/components/CallToAction/component";
import Description from "../Description/component";
import LinkWrap from "../LinkWrap/component";

/*******************************************
 * Image Link Widget Component
 * @return JSX
 ******************************************/

export const ImageLinkWidget = ({
    url,
    imageURL = "",
    descriptionId,
    external = true,
    description,
    callToActionText,
    widgetClassName,
    alt = "",
}) => {
    const getDescription = (description, descriptionId) => {
        return (
            description &&
            descriptionId && (
                <Description id={descriptionId} text={description} />
            )
        );
    };

    const getCallToAction = (callToActionText) => {
        return callToActionText && <CallToAction text={callToActionText} />;
    };

    // Dynamically assign classNames.
    const widgetClasses = classNames(
        "imageLinkWidget",
        "card",
        [descriptionId],
        [widgetClassName]
    );
    const imgClasses = description
        ? classNames("linkImage", "imgWithDescription")
        : "linkImage";

    // Return LinkWrap.
    return (
        <LinkWrap className={widgetClasses} url={url} external={external}>
            <img
                className={imgClasses}
                src={imageURL}
                alt={alt}
                loading="lazy"
            />
            {getDescription(description, descriptionId)}
            {getCallToAction(callToActionText)}
        </LinkWrap>
    );
};

/*****************************
 * Prop Types
 ****************************/
ImageLinkWidget.propTypes = {
    widgetClassName: PropTypes.string,
    url: PropTypes.string,
    imageURL: PropTypes.string,
    descriptionId: PropTypes.string,
    external: PropTypes.bool,
    alt: PropTypes.string,
};

/*****************************
 * Export Component
 ****************************/
export default ImageLinkWidget;
